import type { DashboardMetricMaxColumns } from '@/components/dashboard/dashboard-metric-grid-classes'

export type DashboardMetricDensityColumns = 1 | 2 | 3 | 4

/** Item-count layout for `columnLayout="density"`. */
export function resolveDensityColumns(itemCount: number): DashboardMetricDensityColumns {
  if (itemCount <= 1) return 1
  if (itemCount === 2) return 2
  if (itemCount === 3) return 3
  if (itemCount === 4) return 4
  if (itemCount <= 6) return 3
  if (itemCount <= 8) return 4
  if (itemCount === 9) return 3
  return 4
}

export function clampDensityColumns(
  columns: DashboardMetricDensityColumns,
  maxColumns: DashboardMetricMaxColumns,
): DashboardMetricDensityColumns {
  return Math.min(columns, maxColumns) as DashboardMetricDensityColumns
}

export function resolveDensityGridColumns(
  itemCount: number,
  maxColumns: DashboardMetricMaxColumns,
): DashboardMetricDensityColumns {
  return clampDensityColumns(resolveDensityColumns(itemCount), maxColumns)
}
